export default __webpack_public_path__ + "scene2_4_icona40e7d.png";